import { render, staticRenderFns } from "./ListRegionais.vue?vue&type=template&id=3245cddc&scoped=true"
import script from "./ListRegionais.vue?vue&type=script&lang=js"
export * from "./ListRegionais.vue?vue&type=script&lang=js"
import style0 from "./ListRegionais.vue?vue&type=style&index=0&id=3245cddc&prod&lang=scss"
import style1 from "./ListRegionais.vue?vue&type=style&index=1&id=3245cddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245cddc",
  null
  
)

export default component.exports